<!--
Author: TangChen
Date: 2018-10-17
Desc: 修改登录密码页面，由index.js 配置引入
 -->
<template>
    <div :class="'bizcomp-change-lpwd bizcomp ' + className">
        <comp-title :title="title" />
        <change-pwd :way="way" />
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import changePwd from "@/components/acctInfo/changePwd.vue";
export default {
    name: "ChangeLpwd",
    components: {
        changePwd
    },
    mixins: [mixin],
    data () {
        return {
            way: "login"
        };
    },
    methods: {
    }
};
</script>
<style lang="scss">
@import '../../assets/css/varibles';
.bizcomp-change-lpwd {
}
</style>
